import React, { Children, memo } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function WhatIncludes() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section id="incluye" className="w-full bg-gray-50 py-20 px-4" data-id="element-160">
      <div className="max-w-7xl mx-auto" data-id="element-161">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-162">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-163">
            O que inclui o Mega Pacote?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-164">
            Tudo organizado por etapa e ano escolar — alinhado à BNCC.
          </p>
          <p className="text-2xl font-bold text-red-700 mt-4" data-id="element-165">
            📚 12 Tomos em formato digital PDF
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12" data-id="element-166">
          {/* Fundamental I */}
          <motion.div variants={itemVariants} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow duration-300" data-id="element-167">
            <div className="p-8" data-id="element-168">
              <div className="mb-6" data-id="element-169">
                <img src="https://cdn.magicpatterns.com/uploads/gL1BLd9sqCvFpVWmcsyLEj/heylloyd-image-1771971443562.png" alt="Ensino Fundamental I - Sala de aula com crianças" className="w-full h-64 object-cover rounded-lg" data-id="element-170" />
              </div>

              <div className="mb-6" data-id="element-171">
                <span className="text-sm font-bold text-red-700 uppercase tracking-wide" data-id="element-172">
                  🎨 ENSINO FUNDAMENTAL I
                </span>
                <h3 className="text-2xl font-bold text-gray-900 mt-2 mb-2" data-id="element-173">
                  Anos Iniciais
                </h3>
                <p className="text-gray-600 font-semibold" data-id="element-174">
                  Tomos 01 ao 06 | 1º ao 5º Ano
                </p>
              </div>

              <ul className="space-y-3 mb-6" data-id="element-175">
                <li className="flex items-start text-sm" data-id="element-176">
                  <CheckIcon className="h-5 w-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-177" />
                  <span className="text-gray-700" data-id="element-178">
                    <strong data-id="element-179">Tomo 01</strong> — Alfabetização Visual (Ponto,
                    Linha e Cor)
                  </span>
                </li>
                <li className="flex items-start text-sm" data-id="element-180">
                  <CheckIcon className="h-5 w-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-181" />
                  <span className="text-gray-700" data-id="element-182">
                    <strong data-id="element-183">Tomo 02</strong> — Formas, Texturas e Espaço
                    Criativo
                  </span>
                </li>
                <li className="flex items-start text-sm" data-id="element-184">
                  <CheckIcon className="h-5 w-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-185" />
                  <span className="text-gray-700" data-id="element-186">
                    <strong data-id="element-187">Tomo 03</strong> — Identidade, Folclore e Cultura
                    Popular
                  </span>
                </li>
                <li className="flex items-start text-sm" data-id="element-188">
                  <CheckIcon className="h-5 w-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-189" />
                  <span className="text-gray-700" data-id="element-190">
                    <strong data-id="element-191">Tomo 04</strong> — Patrimônio e Arte Regional
                  </span>
                </li>
                <li className="flex items-start text-sm" data-id="element-192">
                  <CheckIcon className="h-5 w-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-193" />
                  <span className="text-gray-700" data-id="element-194">
                    <strong data-id="element-195">Tomo 05</strong> — Grandes Mestres do Brasil
                  </span>
                </li>
                <li className="flex items-start text-sm" data-id="element-196">
                  <CheckIcon className="h-5 w-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-197" />
                  <span className="text-gray-700" data-id="element-198">
                    <strong data-id="element-199">Tomo 06</strong> — Projetos e Datas Comemorativas
                  </span>
                </li>
              </ul>

              <div className="border-t border-gray-200 pt-4" data-id="element-200">
                <ul className="space-y-2 text-sm text-gray-600" data-id="element-201">
                  <li data-id="element-202">• Atividades lúdicas prontas para imprimir</li>
                  <li data-id="element-203">• Planos de aula passo a passo</li>
                  <li data-id="element-204">• Códigos BNCC em cada atividade</li>
                  <li data-id="element-205">• Avaliações e fichas de observação</li>
                </ul>
              </div>
            </div>
          </motion.div>

          {/* Fundamental II & Médio */}
          <motion.div variants={itemVariants} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow duration-300" data-id="element-206">
            <div className="p-8" data-id="element-207">
              <div className="mb-6" data-id="element-208">
                <img src="https://cdn.magicpatterns.com/uploads/qNtcQQQFkFA8fVZo8Xhpqg/heylloyd-image-1771971825295.png" alt="Ensino Médio - Adolescentes em atividade artística" className="w-full h-64 object-cover rounded-lg" data-id="element-209" />
              </div>

              <div className="mb-6" data-id="element-210">
                <span className="text-sm font-bold text-red-700 uppercase tracking-wide" data-id="element-211">
                  🎨 FUNDAMENTAL II & MÉDIO
                </span>
                <h3 className="text-2xl font-bold text-gray-900 mt-2 mb-2" data-id="element-212">
                  Anos Finais
                </h3>
                <p className="text-gray-600 font-semibold" data-id="element-213">
                  Tomos 07 ao 12 | 6º Ano ao Ensino Médio
                </p>
              </div>

              <ul className="space-y-3 mb-6" data-id="element-214">
                <li className="flex items-start text-sm" data-id="element-215">
                  <CheckIcon className="h-5 w-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-216" />
                  <span className="text-gray-700" data-id="element-217">
                    <strong data-id="element-218">Tomo 07</strong> — Arte Urbana, Graffiti e Estética
                    das Ruas
                  </span>
                </li>
                <li className="flex items-start text-sm" data-id="element-219">
                  <CheckIcon className="h-5 w-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-220" />
                  <span className="text-gray-700" data-id="element-221">
                    <strong data-id="element-222">Tomo 08</strong> — Cultura Digital, Fotografia e
                    Novas Mídias
                  </span>
                </li>
                <li className="flex items-start text-sm" data-id="element-223">
                  <CheckIcon className="h-5 w-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-224" />
                  <span className="text-gray-700" data-id="element-225">
                    <strong data-id="element-226">Tomo 09</strong> — Arte Conceitual e Crítica Social
                  </span>
                </li>
                <li className="flex items-start text-sm" data-id="element-227">
                  <CheckIcon className="h-5 w-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-228" />
                  <span className="text-gray-700" data-id="element-229">
                    <strong data-id="element-230">Tomo 10</strong> — História da Arte Brasileira (Foco
                    ENEM)
                  </span>
                </li>
                <li className="flex items-start text-sm" data-id="element-231">
                  <CheckIcon className="h-5 w-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-232" />
                  <span className="text-gray-700" data-id="element-233">
                    <strong data-id="element-234">Tomo 11</strong> — Design e Indústrias Criativas
                  </span>
                </li>
                <li className="flex items-start text-sm" data-id="element-235">
                  <CheckIcon className="h-5 w-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-236" />
                  <span className="text-gray-700" data-id="element-237">
                    <strong data-id="element-238">Tomo 12</strong> — Projeto de Vida e Portfólio do
                    Aluno
                  </span>
                </li>
              </ul>

              <div className="border-t border-gray-200 pt-4" data-id="element-239">
                <ul className="space-y-2 text-sm text-gray-600" data-id="element-240">
                  <li data-id="element-241">• Conteúdo alinhado ao novo Ensino Médio</li>
                  <li data-id="element-242">• Foco em protagonismo juvenil</li>
                  <li data-id="element-243">• Projetos interdisciplinares prontos</li>
                  <li data-id="element-244">• Material para análise de imagens (ENEM)</li>
                </ul>
              </div>
            </div>
          </motion.div>
        </motion.div>

        {/* Bônus com Imagem */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="mb-12" data-id="element-245">
          <div className="relative rounded-xl overflow-hidden shadow-2xl" data-id="element-246">
            <img src="https://cdn.magicpatterns.com/uploads/j1NnW4kTrUCZ63tT6K7utH/heylloyd-image-1771972462888.png" alt="Bônus Exclusivos - Materiais extras" className="w-full h-64 md:h-80 object-cover" data-id="element-247" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent flex items-end" data-id="element-248">
              <div className="p-8 w-full" data-id="element-249">
                <h3 className="text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-250">
                  🎁 Bônus Exclusivos
                </h3>
                <p className="text-lg md:text-xl text-white/90" data-id="element-251">
                  3 recursos extras incluídos nos dois planos
                </p>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-252">
          <motion.div variants={itemVariants} className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl p-6 border-2 border-amber-200 hover:shadow-lg transition-shadow duration-300" data-id="element-253">
            <div className="text-4xl mb-3" data-id="element-254">🎯</div>
            <h4 className="text-lg font-bold text-gray-900 mb-2" data-id="element-255">Bônus #1</h4>
            <p className="text-sm font-semibold text-gray-800 mb-2" data-id="element-256">
              Aula de Artes em 10 Minutos
            </p>
            <p className="text-sm text-gray-600" data-id="element-257">
              Roteiro Anti-Estresse para conduzir qualquer aula com segurança e
              clareza
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl p-6 border-2 border-amber-200 hover:shadow-lg transition-shadow duration-300" data-id="element-258">
            <div className="text-4xl mb-3" data-id="element-259">📋</div>
            <h4 className="text-lg font-bold text-gray-900 mb-2" data-id="element-260">Bônus #2</h4>
            <p className="text-sm font-semibold text-gray-800 mb-2" data-id="element-261">
              Banco de Avaliação Inteligente
            </p>
            <p className="text-sm text-gray-600" data-id="element-262">
              Rubricas + Pareceres prontos para avaliar sem travar e sem
              subjetividade
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl p-6 border-2 border-amber-200 hover:shadow-lg transition-shadow duration-300" data-id="element-263">
            <div className="text-4xl mb-3" data-id="element-264">🎨</div>
            <h4 className="text-lg font-bold text-gray-900 mb-2" data-id="element-265">Bônus #3</h4>
            <p className="text-sm font-semibold text-gray-800 mb-2" data-id="element-266">
              Ateliê Econômico
            </p>
            <p className="text-sm text-gray-600" data-id="element-267">
              Guia de Materiais Acessíveis + Substituições Inteligentes para
              qualquer escola
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}